import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-ink/10 bg-ink text-paper" data-testid="footer">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold tracking-tighter mb-4">PORTFOLIO</h3>
            <p className="text-sm font-sans text-paper/70 leading-relaxed">
              Diseñador Gráfico & Fotógrafo
              <br />
              Creando experiencias visuales únicas
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-sans tracking-widest uppercase mb-4">Navegación</h4>
            <ul className="space-y-2 text-sm font-sans">
              <li>
                <Link to="/" className="text-paper/70 hover:text-editorial transition-colors" data-testid="footer-home-link">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-paper/70 hover:text-editorial transition-colors" data-testid="footer-about-link">
                  Sobre mí
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-paper/70 hover:text-editorial transition-colors" data-testid="footer-projects-link">
                  Proyectos
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-paper/70 hover:text-editorial transition-colors" data-testid="footer-blog-link">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-paper/70 hover:text-editorial transition-colors" data-testid="footer-contact-link">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-paper/10">
          <p className="text-sm font-sans text-paper/50 text-center">
            © {currentYear} Portfolio. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;